import defineComponent from 'flight';
import uiEffects from 'static/script/utils/ui-effects';
import formatNumber from 'static/script/utils/format-number';

function CartOrderRowUI() {

    this.defaultAttrs({
        orderRowQuantity: '[data-view-cart-quantity]',
        orderRowQuantityInput: '[data-view-cart-quantity]'
    });

    this._changeOrderRowQuantity = function (e) {
        let selectElement = $(e.target);

        if (selectElement.val() < 1) {
            this.trigger(document, 'ui:cart:on-item-remove', { itemId: selectElement.data('itemid') });
        } else if (selectElement.val() === 'change-to-input') { //TODO: what's this magic string? | It's the value from the select box used when the select should transform to an input box
            let input = $('<input type="number" class="view-cart-quantity-input" data-view-cart-quantity min="1" max="' + selectElement.data('quantity-in-shop') + '" data-lastvalue="' + selectElement.data('last-quantity') + '" data-itemid="' + selectElement.data('itemid') + '" value="' + selectElement.data('last-quantity') + '">');
            selectElement.replaceWith(input);
            this.on('change keyup', {
                orderRowQuantityInput : this._changeOrderRowQuantityInput
            });
        } else {
            this._changeOrderRowSum(selectElement);
        }
        selectElement.data('last-quantity', selectElement.val());
    };

    this._removeOrderRow = function () {
        let orderRowQuantityInput = this.select('orderRowQuantity');

        if (orderRowQuantityInput.val() < 1) {
            let orderRow = this.$node;
            orderRow.fadeOut('slow', function () {
                orderRow.remove();
                this.trigger(document, 'ui:cart-after-item-remove', { itemId: orderRowQuantityInput.data('itemid') });
            }.bind(this));
        }
    };

    this._changeOrderRowQuantityInput = function (e) {
        let formElement = $(e.target),
            lastVal = parseInt(formElement.data('data-lastvalue'), 10),
            currVal = parseInt(formElement.val(), 10);

        if (lastVal !== currVal) {
            formElement.data('data-lastvalue', currVal);
            if (parseInt(formElement.val(), 10) > formElement.attr('max')) {
                formElement.val(formElement.attr('max'));
            }

            this._changeOrderRowSum(formElement);
        }
    };

    this._changeOrderRowSum = function (quantityElement) {
        let orderRow = this.$node,
            orderRowSum = 0,
            orderRowSumElement = orderRow.find('[data-view-cart-row-price]'),
            quantity = parseInt(quantityElement.val(), 10) || 0;

        orderRowSum = quantity * orderRowSumElement.data('unit-price');

        orderRowSumElement.html(formatNumber.asMoney(orderRowSum + ' kr'));
        orderRowSumElement.attr('data-row-price', orderRowSum);
        uiEffects.flashBg(orderRow.find('[data-view-cart-item]'), 'confirm');
        this.trigger(document, 'ui:cart:on-item-quantity-set', { itemId: quantityElement.data('itemid'), quantity: quantity });
    };

    this.after('initialize', function () {
        this.on(document, 'data:cart:after-item-remove', this._removeOrderRow);

        this.on('change', {
            orderRowQuantity : this._changeOrderRowQuantity
        });
    });
}

module.exports = defineComponent.component(CartOrderRowUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/cart/cart-order-row-ui.js